import { IsArray, IsString } from 'class-validator';
import { EntityVm } from 'api/core/entity.vm';

export class LocationVm extends EntityVm {
  @IsString()
  warehouseId: string;

  @IsString()
  floor: string;

  @IsArray()
  points: [number, number][];
}
